import { getBusinessInfo } from './getBusinessInfo';
import { opaqueDecrypt } from './cipher';
import Cryptograph from './cryptograph';
import { getGlobalStorage as getGls, setGlobalStorage as setGls, removeGlobalStorage as removeGls } from './storage';

let aeskey = '';

const cryptograph = new Cryptograph({ algorithmName: 'common' });

cryptograph.check(() => {
    aeskey = cryptograph.getStaticSecretKey();
});

/*
 * autor:张建新  zjx@yonyou.com
 * date: 2018/06/28
 * Immutable data constructor for App Component cache
 * ViewModel will support Time travel better , in future
 */

/**
 * @namespace ViewModel
 */
if (!window.__viewModelMap) {
    window.__viewModelMap = new Map().set('data', new Map()).set('metadata', new Map()).set('cstate', new Map());
}

function setData(namespace, v, _runContext) {
    if (typeof v === 'string' && v.length > 23456789) {
        v = null;
    }
    let context = _runContext || window.__QIANKUN_RUNCONTEXT?.runContext;
    if (context?.appKey) {
        namespace = context.appKey + '-' + namespace;
    }

    window.__viewModelMap.get('data').set(namespace, v);
    let $$returnV;
    return $$returnV;
}

function setComponentState(cid, namespace, v, _runContext) {
    let context = _runContext || window.__QIANKUN_RUNCONTEXT?.runContext;
    if (context?.appKey) {
        namespace = context.appKey + '-' + namespace;
    }
    window.__viewModelMap.get('cstate').set(namespace + cid, v);
}

function getComponentState(cid, namespace, _runContext) {
    let context = _runContext || window.__QIANKUN_RUNCONTEXT?.runContext;
    if (context?.appKey) {
        namespace = context.appKey + '-' + namespace;
    }
    return window.__viewModelMap.get('cstate').get(namespace + cid);
}

/**
 * 获取系统上下文数据
 * @memberof ViewModel
 * @returns {object}
 */
function getContext() {
    let c = window.__viewModelMap.sys_Context;
    if (!c) {
        c = initContext();
    }
    let businessInfo = getBusinessInfo();
    if (businessInfo && businessInfo !== {}) {
        Object.assign(c, businessInfo);
    }
    return c;
}

/**
 * 初始化系统上下文数据（空对象），获取上下文，请用getContext
 * @ignore
 * @memberof ViewModel
 * @returns {object}
 */
function initContext() {
    let c = (window.__viewModelMap.sys_Context = {
        environment: {},
        currentOrg: '',
        currentLang: '',
        businessDate: '',
        groupId: '',
        groupName: '',
        userId: '',
        userName: '',
        userCode: '',
        projectCode: '',
    });

    return c;
}

/**
 * 设置localStorage，当前方法没有做加解密，不适合使用
 * @ignore
 * @memberof ViewModel
 * @param {string} key 字段名称
 * @param {string} value 字段值
 */
function setGlobalStore(key, value) {
    let infosFromLocalStorage = localStorage.getItem(key);
    if (!infosFromLocalStorage) {
        localStorage.setItem(key, JSON.stringify(value));
    } else if (JSON.stringify(value) !== localStorage.getItem(key)) {
        localStorage.setItem(key, JSON.stringify(value));
    }
}

/**
 * 判断字符串是否是JSON
 * @memberof ViewModel
 * @param {string} str 字符串
 * @returns {boolean | null}
 */
function isJSON(str) {
    if (typeof str == 'string') {
        try {
            JSON.parse(str);
            return true;
        } catch (e) {
            window.console.log(e);
            window.console.log(str + ':  不是JSON字符串');
            return false;
        }
    }
}

/**
 * 获取localStorage值，当前方法没有做加解密，不适合使用
 * @ignore
 * @memberof ViewModel
 * @param {string} key 字段名称
 * @returns {any}
 */
function getGlobalStore(key) {
    if (key) {
        let infosFromLocalStorage = localStorage.getItem(key);
        if (!infosFromLocalStorage) {
            return null;
        } else {
            if (isJSON(infosFromLocalStorage)) {
                return JSON.parse(infosFromLocalStorage);
            } else {
                return infosFromLocalStorage;
            }
        }
    }
}

/**
 * 删除localStorage值
 * @ignore
 * @memberof ViewModel
 * @param {string} key 字段名称
 */
function removeGlobalStore(key) {
    localStorage.removeItem(key);
}

/**
 * 清空localStorage值
 * @ignore
 * @memberof ViewModel
 * @param {string} key 字段名称
 */
function clearBrowersStore() {
    localStorage.clear();
}

// -- 处理Storage公共方法
/**
 * 设置本地缓存(localStorage或sessionStorage，默认localStorage)，包含本地加解密
 * @memberof ViewModel
 * @param {string} store localStorage或sessionStorage，默认localStorage
 * @param {string} key 缓存字段名称
 * @param {string} value 缓存字段值
 */
function setGlobalStorage(store, key, value, error, unique) {
    if (unique) {
        key = unique + '-' + key;
    }
    setGls(store, key, value, error);
}

/**
 * 获取本地缓存(localStorage或sessionStorage，默认localStorage)，包含本地加解密
 * @memberof ViewModel
 * @param {string} store
 * @param {string} key
 * @returns {object}
 */
function getGlobalStorage(store, key, unique) {
    if (unique) {
        key = unique + '-' + key;
    }
    return getGls(store, key);
}

/**
 * 获取解密数据，也就是可以解密加密后的store缓存数据，注意的是getGlobalStorage获取的数据不需要调用这个方法，localStorage.getItem直接获取的加密才需要这个方法
 * @memberof ViewModel
 * @param {string} data 需要解密的数据
 * @returns {object}
 */
function getDecryptData(data) {
    return localStorage.getItem('storeCipher') != '0' && data !== null ? opaqueDecrypt(data, aeskey) : data;
}

/**
 * 删除本地缓存(localStorage或sessionStorage，默认localStorage)
 * @memberof ViewModel
 * @param {string} store localStorage或sessionStorage，默认localStorage
 * @param {string} key 缓存字段名称
 */
function removeGlobalStorage(store, key) {
    removeGls(store, key);
}

/**
 * 设置cookie(弃用)，处于安全性考虑，系统已不允许更改和设置cookie。
 * @memberof ViewModel
 * @ignore
 * @param {string} key 字段名称
 * @param {string} value 字段值
 * @param {string} path 路径
 * @param {string} domain 域
 * @param {string} day 有效期
 */
function setCookie(key, value, path, domain, day) {
    value = JSON.stringify(value);
    let expires = '',
        setPath,
        setdomain;
    if (day) {
        let d = new Date();
        d.setDate(d.getDate() + day);
        expires = '; expires=' + d.toUTCString();
    }
    if (path) {
        setPath = `; path=${path}`;
    } else {
        setPath = '; path=/nccloud';
    }
    if (domain) {
        setdomain = `; setdomain=${domain}`;
        // 去除写cookie的操作
        // document.cookie = key + '=' + value + expires + setPath + setdomain;
    } else {
        // 去除写cookie的操作
        // document.cookie = key + '=' + value + expires + setPath;
    }
}

/**
 * 获取cookie，setCookie处于安全考虑已弃用，getCookie理论获取不到值
 * @memberof ViewModel
 * @param {string} key 字段名称
 * @returns {string}
 */
function getCookie(key) {
    let cookies = document.cookie;
    let allCookies = cookies.split('; ').reduce((o, item) => {
        let firstIndex = item.indexOf('=');
        o[item.substring(0, firstIndex)] = item.substring(firstIndex + 1);
        return o;
    }, {});
    if (key) {
        return allCookies[key];
    }
    return allCookies;
}

/**
 * 删除cookie，setCookie处于安全考虑已弃用，理论上没有可以删除的cookie
 * @ignore
 * @memberof ViewModel
 * @param {string} key 字段名称
 */
function removeCookie(key) {
    let allCookies = getCookie();
    if (key) {
        setCookie(key, null, null, null, -1);
    } else {
        for (let attr in allCookies) {
            setCookie(attr, null, null, null, -1);
        }
    }
}

/**
 * 计算字符串渲染的dom的长度
 * @memberof ViewModel
 * @param {string} text 字符串
 * @param {string} fontSize 字体大小
 * @param {string} fontFamily 字体系列
 * @returns {number}
 */
function textSize(text, fontSize = '12px', fontFamily = '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei"') {
    var span = document.createElement('span');
    var result = {};
    result.width = span.offsetWidth;
    result.height = span.offsetHeight;
    span.style.visibility = 'hidden';
    span.style.fontSize = fontSize;
    span.style.fontFamily = fontFamily;
    span.style.display = 'inline-block';
    document.body.appendChild(span);
    if (typeof span.textContent != 'undefined') {
        span.textContent = text;
    } else {
        span.innerText = text;
    }
    result.width = parseFloat(window.getComputedStyle(span).width) - result.width;
    result.height = parseFloat(window.getComputedStyle(span).height) - result.height;
    return result;
}

/**
 * 判断某个路径js资源是否已经通过script加载
 * @memberof ViewModel
 * @param {string} src 路径
 * @returns {boolean}
 */
function srcriptAlreadyExist(src) {
    let allScript = document.getElementsByTagName('script');
    let srcriptUrl = Array.from(allScript).map(element => {
        return element.getAttribute('src');
    });
    let index = srcriptUrl.findIndex(val => val === src);
    return index !== -1;
}

function getData(namespace, _runContext) {
    let context = _runContext || window.__QIANKUN_RUNCONTEXT?.runContext;
    if (context?.appKey) {
        namespace = context.appKey + '-' + namespace;
    }
    //YBP-SSC-BUG-1178 打日志定位下问题
    try {
        return window.__viewModelMap.get("data").get(namespace);
    } catch (error) {
        console.log(error, '1111111111111');
        return window.__viewModelMap;
    }
}

function removeDataByContext(_runContext) {
    let context = _runContext || window.__QIANKUN_RUNCONTEXT?.runContext;
    if (context?.appKey) {
        let contextkey = context.appKey + '-';
        let allData = window.__viewModelMap.get('data');
        let allCstate = window.__viewModelMap.get('cstate');
        allData.forEach((value, key) => {
            if (key.startsWith(contextkey)) {
                allData.delete(key);
            }
        });
        allCstate.forEach((value, key) => {
            if (key.startsWith(contextkey)) {
                allCstate.delete(key);
            }
        });
    }
}

/**
 * 缓存模板的数据到页面全局
 * @memberof ViewModel
 * @param {string} namespace 字段名称
 * @param {any} value 值
 */
function setMetadata(namespace, v) {
    window.__viewModelMap.get('metadata').set(namespace, v);
}

/**
 * 获取setMetadata缓存的数据
 * @memberof ViewModel
 * @param {string} namespace 字段名称
 * @returns {any}
 */
function getMetadata(namespace) {
    return window.__viewModelMap.get('metadata').get(namespace);
}

function getImmutableDataByNamespace() { };

function allHooks() {
    return {
        setData,
        setComponentState,
        getComponentState,
        getContext,
        initContext,
        setGlobalStore,
        getGlobalStore,
        removeGlobalStore,
        clearBrowersStore,
        setGlobalStorage,
        getGlobalStorage,
        removeGlobalStorage,
        setCookie,
        removeCookie,
        getMetadata,
        setMetadata,
        removeDataByContext,
        getData,
        getCookie,
        getDecryptData,
    };
}

export default allHooks();

